import classNames from 'classnames';
import React from 'react';

import css from './Sidebar.module.css';

interface IProps {
  isHiddenOnMobile?: boolean;
}

const Sidebar: React.FC<React.PropsWithChildren<IProps>> = ({
  isHiddenOnMobile = false,
  children,
}) => {
  const hiddenOnMobile = isHiddenOnMobile ? css.sidebarHiddenOnMobile : '';
  return (
    <div className={classNames([css.sidebar, hiddenOnMobile])}>
      <div className={css.sidebarContent}>{children}</div>
    </div>
  );
};
export default Sidebar;
